import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<a title={{t \"general.returnToPreviousPage\"}} class=\"back-link\" href=\"#\" {{on \"click\" (prevent-default this.back)}}>\n  <FaIcon @icon=\"angles-left\" /> {{t \"general.back\"}}\n</a>\n", {
  moduleName: "ilios-common/components/back-link.hbs"
});